import { useState, Suspense } from 'react';

import { ActivityResponse } from 'generated';
import { useTranslation } from 'react-i18next';

import { queries } from 'RestAPIs/rapini';

import { Typography } from '@mui/material';

import { DataGrid, Dialog } from 'components/shared';

import AddActivityDialog from './AddActivityDialog';

interface Props {
  open: boolean;
  handleClose: () => void;
}

export default function ActivitiesDialog({ open, handleClose }: Props) {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [activityToEdit, setActivityToEdit] = useState<
    ActivityResponse | undefined
  >();

  const { data: activities } = queries.useGetActivities(
    //@ts-expect-error TODO: BE should accept array of ids
    'WORKPLACE',
    undefined,
    {
      enabled: open
    }
  );

  const columns = [
    {
      field: 'name',
      headerName: t('name'),
      flex: 1,
      minWidth: 150
    },
    {
      field: 'code',
      headerName: t('code'),
      flex: 1,
      minWidth: 150
    },
    {
      field: 'description',
      headerName: t('description'),
      flex: 1,
      minWidth: 150
    },
    {
      field: 'requiredQualifications',
      headerName: t('qualifications'),
      flex: 1,
      minWidth: 150
    }
  ];

  const rows =
    activities?.map((a) => ({
      ...a,
      id: a.entityId,
      requiredQualifications: a?.requiredQualifications
        .map((q) => q.name)
        .join(', ')
    })) ?? [];

  function onAddClick() {
    setActivityToEdit(undefined);
    setDialogOpen(true);
  }

  function onEditClick(id) {
    const editValues = activities?.find((a) => a.entityId === id);

    setActivityToEdit(editValues);
    setDialogOpen(true);
  }

  return (
    <Dialog
      title={t('activityPlanning.manageActivities')}
      maxWidth="xl"
      open={open}
      handleClose={handleClose}
      onClose={handleClose}
      PaperProps={{
        sx: { width: '100%' }
      }}
    >
      <Suspense fallback={<Typography>Loading</Typography>}>
        <DataGrid
          columns={columns}
          rows={rows}
          onAddClick={onAddClick}
          onAddClickTitle={t('new')}
          onEditClick={onEditClick}
          addRowDialog={
            <AddActivityDialog
              open={dialogOpen}
              activity={activityToEdit}
              handleClose={() => setDialogOpen(false)}
            />
          }
        />
      </Suspense>
    </Dialog>
  );
}
